/**
 * The shell's own path builders: the segments above any app's mount point.
 *
 * The shell owns the prefix and nothing below it, so this holds the customer segment alone. Paths
 * beneath an app's mount point belong to that app and are built by its own module (Scout's are in
 * `apps/scout/paths.ts`), which is what lets an app change its routes without the shell knowing them.
 *
 * The customer is percent-encoded: it comes from the URL, so it is not guaranteed path-safe.
 */

/** The customer-scoped root, whose index redirects on to an app. */
export const getCustomerPath = (customer: string): string =>
  `/c/${encodeURIComponent(customer)}`
